import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetForm!: FormGroup;
  captchaQuestion: string = '';
  captchaAnswer: number = 0;
  errorMessage: string = '';
  successMessage: string = '';
  isLoading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.generateCaptcha();
  }

  private initializeForm(): void {
    this.resetForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      captchaInput: ['', [Validators.required]]
    });
  }

  generateCaptcha(): void {
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    this.captchaAnswer = num1 + num2;
    this.captchaQuestion = `What is ${num1} + ${num2}?`;
  }

  onSubmit(): void {
    this.errorMessage = '';
    this.successMessage = '';

    if (this.resetForm.invalid) {
      this.errorMessage = 'Please enter a valid email address.';
      return;
    }

    const userCaptchaAnswer = parseInt(this.resetForm.get('captchaInput')?.value);
    if (userCaptchaAnswer !== this.captchaAnswer) {
      this.errorMessage = 'Captcha answer is incorrect. Please try again.';
      this.generateCaptcha();
      this.resetForm.patchValue({ captchaInput: '' });
      return;
    }

    this.isLoading = true;
    this.sendResetOTP();
  }

  private sendResetOTP(): void {
    const email = this.resetForm.get('email')?.value;

    // This is a mockup - just simulate the action
    setTimeout(() => {
      console.log('Mockup Reset password for:', email);
      this.successMessage = `OTP has been sent to ${email}. Redirecting to verify OTP page...`;
      this.isLoading = false;
      this.resetForm.reset();
      this.generateCaptcha();

      setTimeout(() => {
        this.router.navigate(['/auth-mockup/verify-otp']);
      }, 3000);
    }, 1000);
  }

  get f() {
    return this.resetForm.controls;
  }

  goToSignIn(): void {
    this.router.navigate(['/auth-mockup/sign-in']);
  }

  goToHome(): void {
    this.router.navigate(['/']);
  }
}
